<template>
  <div>
    <breadcrumbs :home="item.name + ': Reassign lot'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <v-combobox v-model="transaction.lotFrom" outlined dense label="From lot" :items="currentLots" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <v-combobox v-model="transaction.lotTo" outlined dense label="To lot" :items="currentLots" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
              </v-col>
              <v-col cols="12" sm="6" lg="4" v-if="sites.length>1">
                <v-autocomplete outlined dense label="Site" v-model="transaction.siteId" :items="sites" item-value="id" item-text="name"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Quantity" v-model="transaction.quantity" :precision="item.precision" prefix="" :suffix="item.trackUnits"
                                      :hint="transactionId ? '' : currentQuantity"/>
              </v-col>
            </v-row>

            <v-row dense >
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense :rules="[fieldRules.maxLength(255)]" counter="255"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-divider/>
        <v-card-actions class="px-6">
          <v-switch v-if="transactionId && $store.getters.company.permissions.includes('inventory.write')"
                    v-model="edit" label="Edit" hide-details class="mt-0" :disabled="dirty"/>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryItemsTransferLot',
  mixins: [confirmLeave],
	props: {
    itemId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      edit: false,
      item: {name:'',sites:[]},
      valid:true,
      saving:false,
      value: 0,
      transaction: {itemId:this.itemId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), quantity: 0, siteId:'', lotFrom:'', lotTo:'', comments: ""},
      dirty: false
		}
  },
  computed: {
    sites() {
      return this.$store.getters.sites(!this.transactionId);
    },
    currentLots() {
      return this.item.sites.filter(site => site.siteId === this.transaction.siteId).map(site => site.lot);
    },
    currentQuantity() {
      const site = this.item.sites.find(site => site.siteId === this.transaction.siteId && site.lot === this.transaction.lotFrom);
      return site ? this.$number(site.quantity, this.item.precision) : '';
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    this.transaction.siteId = this.sites[0].id;
    const results = await this.$apiCall(`query InventoryItemsTransferLot($id:ID!,$edit:Boolean!) {
                                              itemTransferLot(id:$id) @include(if:$edit) {
                                                itemId,date,siteId,lotFrom,lotTo,quantity,comments
                                              }
                                              lotUnique(prefix:"I") @skip(if:$edit)
                                            }`,
                                        {id:this.transactionId||'',edit:this.transactionId!=undefined});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    if (this.transactionId) {
      this.transaction = results.data.itemTransferLot;
      this.transaction.id = this.transactionId;
    }

    await this.refresh();
    if (!this.transactionId) {
      this.transaction.lotTo = results.data.lotUnique;
      this.edit = true;
      this.$nextTick(() => {
        this.$refs.form.validate();
      })
    }
    this.$nextTick(() => this.dirty = false);
  },

	methods: {
    async refresh() {
      const results = await this.$apiCall(`query InventoryItemsTransferLot($id:ID!, $date:DateTime!) {
                                                item(id:$id) {
                                                  id,name,active,trackUnits,lotTracking,precision,
                                                  sites(asof:$date) {siteId,lot,quantity}
                                                }
                                              }`,
                                          {id:this.transaction ? this.transaction.itemId : this.itemId,
                                           date:this.transaction.date});
      if (!results.error) {
        this.item = results.data.item;
        if (!this.item.lotTracking) {
          this.$nextTick(() => this.dirty = false);
          this.$router.back();
        }
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const results = await this.$apiCall(`mutation InventoryItemsTransferLot($input: ItemTransferLotInput!) {
                                              itemTransferLotCreate(input:$input) {id}
                                            }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} reassign lot transaction for item ${this.item.name}`});
        }
      }
		}
	}
}
</script>